/* スマホ用の固定バー（価格 + 購入ボタン）。
   経緯とねらいは snippets/sticky-atc.liquid のコメント。

   **本物の要素から写す。** 価格の文字・在庫の状態・ボタンの文言を自分で
   組み立てると、バリアントの切り替え・通貨の切り替え・売り切れの3つを
   二重に持つことになり、必ずどこかで食い違う。ここは鏡でしかない。 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var priceOut = bar.querySelector('[data-sticky-atc-price]');
  var button = bar.querySelector('[data-sticky-atc-button]');

  /* 本物の送信ボタンと価格。product-info の中にしか無い（関連商品の
     価格を拾わないよう、範囲を絞る） */
  var scope = document.querySelector('product-info') || document;
  function realButton() {
    return scope.querySelector('.product-form__submit');
  }
  /* **見えている方を選ぶ。** 価格の要素は3つあり（通常・セール・控え）、
     見えているのは常に1つだけ。順番はセール中かどうかで変わるので、
     querySelector で先頭を取ると、セールになった瞬間に空を写す */
  function realPrice() {
    var all = scope.querySelectorAll('.price__container .price-item--sale, ' +
                                     '.price__container .price-item--regular');
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null && all[i].textContent.trim()) return all[i];
    }
    return all[0] || null;
  }

  /* **変わっていないなら書かない。** このバーは監視している範囲
     （product-info）の中にある。`textContent` は同じ文字列を代入しても
     変更として記録されるので、素直に書くと

         書く → MutationObserver が発火 → 書く → …

     で無限に回り、メインスレッドが占有されてページが描画されなくなる。
     2026-09-08 に実際にそうなり、商品ページが白紙のまま止まった。 */
  function setText(el, value) {
    if (el.textContent !== value) el.textContent = value;
  }

  function sync() {
    var b = realButton();
    var p = realPrice();
    if (p && p.textContent.trim()) setText(priceOut, p.textContent.trim());
    if (!b) return;
    /* 売り切れ・数量制限は本物のボタンが disabled で表している。
       文言も本物に合わせる（「Sold out」等の翻訳を自前で持たない） */
    if (button.disabled !== b.disabled) button.disabled = b.disabled;
    var label = (b.querySelector('span') || b).textContent.trim();
    if (label) setText(button, label);
  }

  button.addEventListener('click', function () {
    var b = realButton();
    if (!b || b.disabled) return;
    /* **本物を押す。** ここで自前にカートへ投げると、カートドロワーの
       開閉・在庫エラーの表示・計測イベントを全部作り直すことになる */
    b.click();
  });

  /* 本物のボタンが見えているあいだは出さない。同じものが2つ並ぶと、
     どちらが効くのか分からなくなる */
  var target = realButton();
  if (!target) return;

  function show(on) {
    bar.classList.toggle('is-shown', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  /* **初回は同期で決める。** IntersectionObserver の初回コールバックだけに
     任せると、それが来ない状況（描画されていないタブなど）で永久に出ない。
     本物のボタンが画面の下端より下にあれば出す、というだけの判定。 */
  function offscreen() {
    var r = target.getBoundingClientRect();
    return r.top > (window.innerHeight || 0) - 20 || r.bottom < 0;
  }
  show(offscreen());

  if ('IntersectionObserver' in window) {
    /* **観測器の参照を残す。** 参照を持たない観測器は回収されうる */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
    }, { rootMargin: '0px 0px -20px 0px' });
    io.observe(target);
    bar.__io = io;
  } else {
    /* 古い端末。巻き上げ量から自分で判定する */
    window.addEventListener('scroll', function () { show(offscreen()); },
                            { passive: true });
    window.addEventListener('resize', function () { show(offscreen()); });
  }

  sync();
  /* バリアントの切り替えで product-info の中身が差し替わる。
     属性の変化まで見ないと、売り切れになったことに気づけない。

     **入れ子の発火を止める二重の備え。** 上の setText で「変わっていない
     なら書かない」ようにしてあるが、通知は非同期にまとまって届くので、
     処理中に自分の書き込みぶんが混ざることがある。旗を立てて弾く。 */
  var syncing = false;
  var mo = new MutationObserver(function () {
    if (syncing) return;
    syncing = true;
    try { sync(); } finally { syncing = false; }
  });
  mo.observe(scope, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['disabled', 'class'],
  });
  bar.__mo = mo;
})();
